var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"frameMain"},[_c('component-header'),_c('component-board'),_c('component-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }